import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptQuickLink } from "../adapters/adaptQuickLinks";

const fetchQuickLink = async (id: number) => {
	const response = await cmsClient.get<IQuickLink>(
		`/homepage/admin/quicklink/${id}/`
	);

	return response.data;
};

const useQuickLink = (id: number) => {
	const query = useQuery(["quick-link", id], () => fetchQuickLink(id), {
		select: adaptQuickLink,
		enabled: !!id
	});

	return query;
};

export default useQuickLink;
